export default "__VITE_ASSET__e1fa4fd0__"